<template>
  <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
  <v-container v-else>
    <v-layout row wrap>
      <v-flex xs3>
            <v-btn @click="addMode = addMode == 1 ? 0 : 1" :color="addMode == 1 ? 'success darken-3' : 'success' ">
              <v-icon>add_to_photos</v-icon>
            </v-btn>
            <v-btn v-if="false" @click="addMode = addMode == 2 ? 0 : 2" :color="addMode == 2 ? 'success darken-3' : 'success' ">
              <v-icon>add</v-icon>
            </v-btn>
      </v-flex>
      <v-flex :class="addMode == 1 ? 'add-document_wraper active' : 'add-document_wraper inactive'"  xs12>
        <New :hideQueueButton="true" style="background-color: whitesmoke"></New>
      </v-flex>
      <v-flex v-if="false" :class="addMode == 2 ? 'add-document_wraper active' : 'add-document_wraper inactive'"  xs12>
        <NewMulti  style="background-color: whitesmoke"></NewMulti>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex  offset-xs10 md1 xs2>
        <v-icon @click="changeMode(1)"  :color="mode ==1 ? 'primary' : 'gray'" class="icon">toc</v-icon>
        <v-icon @click="changeMode(2)" :color="mode ==2 ? 'primary' : 'gray'" class="icon">view_list</v-icon>
        <v-icon @click="changeMode(3)" :color="mode ==3 ? 'primary' : 'gray'" class="icon">view_quilt</v-icon>
      </v-flex>
    </v-layout>
    <v-data-table v-if="mode == 1" :headers="headers" :items="documents" class="elevation-1" :loading="loading"
                  no-data-text="Brak dokumentów" :rows-per-page-items="pagination.rowsPerPageItems"  :pagination.sync="pagination">

      <template v-slot:items="props">
        <td class="text-overflow">{{ props.item.id }}</td>
        <td class="text-overflow">{{ getUser(props.item.created_by) }} </td>
        <td class="text-overflow"> {{ props.item.created_at }}</td>
        <td class="text-overflow">{{ props.item.archive.custom_name }}</td>
        <td class="text-overflow"> {{getSchemaName(props.item.schema.id)}}</td>
        <td class="text-overflow"> {{getWorkerFullName(props.item.worker_guid)}}</td>
        <td class="text-overflow">
          <v-icon :color="props.item.signed == 1 ? 'green darken-3' : 'red darken-3'">
            {{props.item.signed == 1  ? "mdi-pencil" : "mdi-pencil-off"}}
          </v-icon>
        </td>
        <td>
          <v-tooltip v-if="props.item.status == 1" bottom>
            <template  v-slot:activator="{ on }">
              <v-progress-circular  v-on="on" color="primary" style="width: 1rem" small indeterminate></v-progress-circular>
            </template>
            <span v-if="props.item.status == 1">Trwa skanowanie dokumentu</span>
          </v-tooltip>
          <span v-else-if="props.item.status == 2" ><v-icon color="orange darken-3">task_plus</v-icon></span>
          <span v-else><v-icon color="red darken-3">error</v-icon></span>

        </td>
        <td>
          <v-btn :disabled="props.item.status != 2" @click="createForm(props.item.id)" small  icon>
            <v-icon color="green darken-3">pageview</v-icon>
          </v-btn>
          <v-btn @click="deleteDocument(props.item.id)" small  icon>
            <v-icon color="red darken-2">delete_forever</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

    <v-data-iterator
        v-if="mode == 2"
        :items="documents"
        :pagination.sync="pagination"
        content-tag="v-layout"
        hide-actions
        no-data-text="Brak dokumentów"
        row
        wrap
    >
      <template v-slot:item="props">
        <v-flex lg12>
          <DocumentListView :item="props.item" :schemas="schemas">
            <template   v-slot:actions="{item}">
              <v-btn :disabled="item.status == 1" color="green" @click="createForm(item.id)">Przypisz</v-btn>
              <v-progress-circular v-if="item.status == 1" indeterminate></v-progress-circular>
            </template>
          </DocumentListView>
        </v-flex>
      </template>
      <template v-slot:footer>
        <v-flex xs2 offset-xs5>
          <v-btn color="primary" :disabled="pagination.rowsPerPage>= documents.length" @click="loadMore()">
            Załaduj więcej
          </v-btn>
        </v-flex>
      </template>
    </v-data-iterator>

    <v-container fluid grid-list-lg>
    <v-data-iterator
        v-if="mode == 3"
        :items="documents"
        :pagination.sync="cardPagination"
        :rows-per-page-items ="[3,12,24]"
        content-tag="v-layout"
        no-data-text="Brak dokumentów"
        row
        wrap
    >
      <template v-slot:item="props">
        <v-flex lg4>
          <DocumentCardView :item="props.item" :schemas="schemas"></DocumentCardView>
        </v-flex>
      </template>
    </v-data-iterator>
    </v-container>

  </v-container>
</template>

<script>
import DocumentCardView from "@/components/document/DocumentCardView"
import TextInput from "@/components/form/inputs/Text"
import NumberInput from "@/components/form/inputs/Number"
import DateInput from "@/components/form/inputs/Date"
import TimeInput from "@/components/form/inputs/Time"
import RadioInput from "@/components/form/inputs/Radio"
import TableInput from "@/components/form/inputs/Table"
import MultipleInput from "@/components/form/inputs/Multiple"
import SignatureInput from "@/components/form/inputs/Signature"
import PhotoInput from "@/components/form/inputs/Photo"
import CodeInput from "@/components/form/inputs/Code"
import ArchiveInput from "@/components/form/inputs/Archive"
import RelatedInput from "@/components/form/inputs/Related"
import DependInput from "@/components/form/inputs/SelectDepend"
import CheckboxInput from "@/components/form/inputs/Checkbox"
import Presentation from "@/components/form/Presentation"
import PDFViewer from "@/components/pdf/Viewer"
import Messenger from "@/plugins/Messenger"
import DocumentListView from "@/components/document/DocumentListView"
import DynamicCardView from "@/components/common/DynamicCardView"
import New from './New'
import NewMulti from './NewMulti'
import NewWorker from "@/components/document/worker/NewWorker"
import Settings from "@/plugins/Settings"

export default {
  name: "Waiting",
  components:{
    NewMulti,
    NewWorker,
    New,
    DocumentCardView,
    DynamicCardView,
    DocumentListView,
    TextInput,
    NumberInput,
    DateInput,
    TimeInput,
    RadioInput,
    TableInput,
    MultipleInput,
    SignatureInput,
    PhotoInput,
    CodeInput,
    ArchiveInput,
    RelatedInput,
    DependInput,
    CheckboxInput,
    Presentation,
    PDFViewer
  },
  data:()=>({
    headers: [
      {text : 'Id',value : 'id', width: "70px",align: 'center'},
      {text : 'Autor',align: 'center'},
      {text : 'Utworzono',value : 'created_at',align: 'center'},
      {text : 'Nazwa pliku',value : 'schema.name',align: 'center'},
      {text : 'Typ',value : 'schema.name',align: 'center'},
      {text : 'Pracownik',value : 'worker_guid',align: 'center'},
      {text : 'Podpis',value : 'signed', width: "70px",align: 'left'},
      {text : 'Status',value : 'status', width: "70px",align: 'left'},
      {text : 'Akcje', width: "150px", align: 'left'}
    ],
    addMode : false,
    documents : [],
    pollInterval : [],
    mode : 1,
    fields :[],
    lock : false,
    file:null,
    schemaAssigned :{},
    workers :[],
    schemas : [],
    loading : true,
    pagination: {
      rowsPerPage: 10
    },
    cardPagination: {
      rowsPerPage: 3
    },
    translations :{
      name : "Imie",
      surname : "Nazwisko",
      pesel : "Pesel",
      id_number: "Numer dokumentu",
      created_at : "Utworzono"
    }
  }),
  created() {
    this.loading = true
    let schemas = this.$http.get('document/schemas')
    let documents = this.$http.get('document/waiting')
    let workers = this.$http.get('document/workers')
    this.initWebsocket()

    Promise.all([schemas, documents, workers])
      .then(data => {
        this.schemas = data[0].data
        this.documents = data[1].data
        this.workers = data[2].data
        this.loading = false
        if (!Settings.websocketAvallible()) {
          this.pollingStatusDocuments(this.documents)
          this.pollInterval[0] = setInterval(this.pollingNewDocuments, 5000)
        }
      })
      .catch(() => Messenger.emitError("Błąd pobierania danych"))
  },
  destroyed() {
    this.clearIntervals()
    this.$websocket.disconnect()
  },
  methods:{
    deleteDocument(id){
      this.$confirm("Czy jesteś pewien, że chcesz usunąć dokument? Operacja jest nieodwracalna.").then((res)=> {
        if (res) {
          this.$http.delete(`document/${id}`).then(() => {
            this.documents = this.documents.filter(doc => doc.id != id)
            Messenger.emitSuccess("Usunięto dokument")
          }).catch(() => Messenger.emitError("Nie można usunąć dokumentu"))
        }
      })
    },
    loadMore(){
      this.pagination.rowsPerPage = (this.pagination.rowsPerPage + 5 < this.documents.length) ?
        this.pagination.rowsPerPage + 5 : this.documents.length
    },
    getSchemaName(id){
      let schema = this.schemas.find(schema => schema.id == id)
      return schema ? schema.name : ""
    },
    getWorkerFullName(guid){
      let worker = this.workers.find(worker => worker.guid == guid)
      return worker ? worker.name + " " + worker.surname : ""
    },
    changeMode(mode){
      this.mode = mode
    },
    createForm(documentId){
      this.clearIntervals()
      this.$router.push(`/document/${documentId}/create-form`)
    },
    assign(documentId){
      let schemaId = this.schemaAssigned[documentId]
      if(!(schemaId >0)){
        Messenger.emitError("Najpierw wybierz schemat")
        return
      }
      let data = {'schema_id' :schemaId, 'document_id' : documentId }
      this.$http.post('document/ocr/assign', data).then(() => {
        this.documents = this.documents.filter(docs => docs.id != documentId)
      }).catch(()=>Messenger.emitError("Błąd"))
    },
    base64toPDF(data) {
      var bufferArray = this.base64ToArrayBuffer(data);
      var blobStore = new Blob([bufferArray], { type: "application/pdf" });
      return blobStore
    },
    base64ToArrayBuffer(data) {
      var bString = window.atob(data);
      var bLength = bString.length;
      var bytes = new Uint8Array(bLength);
      for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    getInputComponent(type) {
      return type + "-input"
    },
    getUser(id){
      let user = this.$store.getters.user(id)
      if(!user)
        return ""
      return user.name + " " + user.surname
    },
    getStatus(status){
      switch (parseInt(status)){
      case 1:
        return "Trwa skanowanie"
      case 2:
        return "Oczekuje"
      default:
        return "Inny"
      }
    },
    pollingStatus(doc){
      this.$http.get('document/' + doc.id).then(data =>{
        if(data.data.status == 1){
          return
        }
        clearInterval(this.pollInterval[doc.id])
        this.replaceDocumentData(data)
      })
    },
    replaceDocumentData(data){
      let document = this.documents.find(document => document.id == data.data.id)
      document.status = data.data.status
      document.worker_guid = data.data.worker_guid
      document.schema = data.data.schema
      document.signed = data.data.signed
    },
    documentSplited(data){
      if(data.data.count > 0){
        return Messenger.emitSuccess("Rozpoczęto dodawanie " + data.data.count + " dokumentów")
      }
      return Messenger.emitError("Bład podczas dzielenia dokumentów")
    },
    pollingStatusDocuments(docs){
      docs.filter(doc => doc.status == 1)
        .forEach(doc => this.pollInterval[doc.id] = setInterval(() => this.pollingStatus(doc), 5000))
    },
    pollingNewDocuments(){
      let maxId =  this.documents.length > 0 ?
        this.documents.reduce((prev, current) => (parseInt(prev.id) > parseInt(current.id)) ? prev : current).id : 0
      this.$http.get('document/waiting?gteId=' + maxId).then(data =>{
        this.documents = [...this.documents, ...data.data]
        this.pollingStatusDocuments(data.data)
      })
    },
    clearIntervals(){
      this.pollInterval.forEach(ref => clearInterval(ref))
    },
    initWebsocket(){
      if(Settings.websocketAvallible()) {
        this.$websocket.createConnection()
        this.$websocket.registry('new_document',(data) => this.documents.push(data.data))
        this.$websocket.registry('document_processed',(data) => this.replaceDocumentData(data))
        this.$websocket.registry('document_splited',(data) => this.documentSplited(data))
      }
    }
  },
}
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.active{
  display: block;
  opacity: 1;
  animation: fadeIn 0.9s;
}
.inactive{
  display: none;
  opacity: 0;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  border: 3px solid green;
}

.text-overflow {
  text-align: center;
  word-wrap: break-word;
  vertical-align: middle;
  white-space: normal;
}



</style>